import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "./components/layout/Header";
import { Footer } from "./components/layout/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Candidates from "./pages/Candidates";
import Organizations from "./pages/Organizations";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Disclaimer from "./pages/Disclaimer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import Pricing from "./pages/Pricing";
import CandidateDashboard from "./pages/CandidateDashboard";
import OrganizationDashboard from "./pages/OrganizationDashboard";
import CandidateFullView from "./pages/CandidateFullView";
import PlanSelection from "./pages/PlanSelection";
import ReferenceResponse from "./pages/ReferenceResponse";
import AdminDashboard from "./pages/AdminDashboard";
import { WhatsAppButton } from "./components/WhatsAppButton";

// Protected route component
const ProtectedRoute = ({ children, requiredUserType }) => {
  const user = localStorage.getItem('user');
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (requiredUserType) {
    const userData = JSON.parse(user);
    if (userData.user_type !== requiredUserType) {
      return <Navigate to="/dashboard" replace />;
    }
  }
  return children;
};

// Dashboard redirect based on user type
const DashboardRedirect = () => {
  const user = localStorage.getItem('user');
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  const userData = JSON.parse(user);
  if (userData.user_type === 'admin') {
    return <Navigate to="/admin-dashboard" replace />;
  }
  if (userData.user_type === 'organization') {
    return <Navigate to="/organization-dashboard" replace />;
  }
  return <Navigate to="/candidate-dashboard" replace />;
};

const Layout = ({ children }) => {
  const location = useLocation();
  const isAuthPage = location.pathname === '/login' || location.pathname === '/signup' || location.pathname === '/plan-selection';
  const isDashboardPage = location.pathname.includes('dashboard') || location.pathname.includes('candidate-view');
  const isRefPage = location.pathname.includes('reference-response');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      {!isAuthPage && !isDashboardPage && !isRefPage && <Header />}
      <main>{children}</main>
      {!isAuthPage && !isDashboardPage && !isRefPage && <Footer />}
      <WhatsAppButton />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/candidates" element={<Candidates />} />
            <Route path="/organizations" element={<Organizations />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/dashboard" element={<DashboardRedirect />} />
            <Route path="/plan-selection" element={<PlanSelection />} />
            <Route path="/reference-response/:token" element={<ReferenceResponse />} />
            <Route 
              path="/candidate-dashboard" 
              element={
                <ProtectedRoute requiredUserType="candidate">
                  <CandidateDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/organization-dashboard" 
              element={
                <ProtectedRoute requiredUserType="organization">
                  <OrganizationDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/candidate-view/:candidateId" 
              element={
                <ProtectedRoute requiredUserType="organization">
                  <CandidateFullView />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin-dashboard" 
              element={
                <ProtectedRoute requiredUserType="admin">
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
